
export enum IFileLocationType {
  Temporary = "temporary",
  Inventory = "inventory"
}